// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const TextWrapper: StatelessFunctionalComponent<*> = styled.div`
  font-size: 1.8em !important;
  line-height: 1.5;

  .Text {

    &-question {
      padding: 0px 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-detail {
      font-size: 0.8em;
      text-align: center;
      color: var(--text-color-1);
    }

    &-error {
      max-width: 800px;
      margin: 0 auto;
      padding: 5px;
      text-align: center;
      color: red;
    }

    &-loader {
      text-align: center;
      color: var(--text-color-1);
    }

    &-question--bold {
      line-height: 1.5;
      font-weight: 500;
      text-align: center;
      color: var(--text-color-1);
      margin-top: 1rem;
    }

    &-question--unit {
      font-size: 12px;
      padding-left: 3px;
      text-align: center;
      color: var(--text-color-1);
    }
  }

`;

export default TextWrapper;
